import { useState } from "react";

import { Star } from "lucide-react";

import { SimpleTooltip } from "@/components/ui/tooltip";

const SCORE_LABELS: Record<number, string> = {
  1: "Very Unhelpful",
  2: "Unhelpful",
  3: "OK",
  4: "Helpful",
  5: "Very Helpful",
};

interface StarRatingProps {
  score?: number;
  readOnly?: boolean;
  onSelect: (score: number) => void;
}

export function StarRating({ score, readOnly, onSelect }: StarRatingProps) {
  const [hoverIdx, setHoverIdx] = useState<number>();

  return (
    <div className="flex">
      {[1, 2, 3, 4, 5].map((i) => {
        const active = hoverIdx ? i <= hoverIdx : score ? i <= score : false;
        return (
          <button
            key={i}
            type="button"
            className={`${i === 5 ? "" : "pr-6"} ${
              readOnly ? "cursor-default" : "cursor-pointer"
            }`}
            onClick={readOnly ? undefined : () => onSelect(i)}
            onMouseEnter={readOnly ? undefined : () => setHoverIdx(i)}
            onMouseLeave={readOnly ? undefined : () => setHoverIdx(undefined)}
            disabled={readOnly}
          >
            <SimpleTooltip content={SCORE_LABELS[i]} delayDuration={0}>
              <Star
                size={36}
                className={
                  active
                    ? "text-blue-700 fill-blue-700"
                    : "text-gray-500 fill-transparent"
                }
              />
            </SimpleTooltip>
          </button>
        );
      })}
    </div>
  );
}
